import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { X } from '@styled-icons/feather';
import styles from './PopupNotice.module.css';

function PopupNotice({
  className,
  icon,
  children,
  top,
  bottom,
  left,
  right,
  open,
  onClose,
}: PropsWithChildren<{
  className?: string;
  icon?: any;
  top?: boolean;
  bottom?: boolean;
  left?: boolean;
  right?: boolean;
  open: boolean;
  onClose: () => void;
}>) {
  return (
    <div
      className={classNames(styles.popupContainer, className, {
        [styles.popupContainerTop]: top,
        [styles.popupContainerBottom]: bottom,
        [styles.popupContainerRight]: right,
        [styles.popupContainerLeft]: left,
        [styles.popupContainerTopOpen]: open && top,
        [styles.popupContainerBottomOpen]: open && bottom,
        [styles.popupContainerCenter]: !right && !left,
      })}
    >
      <div className={styles.icon}>{icon}</div>
      <div className={styles.content}>{children}</div>
      <div
        role="none"
        className={classNames(styles.iconClose, 'with-text-color')}
        onClick={onClose}
      >
        <X size={20} />
      </div>
    </div>
  );
}

export default PopupNotice;
